var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosRadioButtonOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.07692C9.85 1.07692 11.5885 1.79615 12.8962 3.10385C14.2038 4.41154 14.9231 6.15 14.9231 8C14.9231 9.85 14.2038 11.5885 12.8962 12.8962C11.5885 14.2038 9.85 14.9231 8 14.9231C6.15 14.9231 4.41154 14.2038 3.10385 12.8962C1.79615 11.5885 1.07692 9.85 1.07692 8C1.07692 6.15 1.79615 4.41154 3.10385 3.10385C4.41154 1.79615 6.15 1.07692 8 1.07692ZM8 0C3.58077 0 0 3.58077 0 8C0 12.4192 3.58077 16 8 16C12.4192 16 16 12.4192 16 8C16 3.58077 12.4192 0 8 0Z",
    fill: "#FB6240"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1346 3.86539C11.0308 2.76154 9.56154 2.15385 8 2.15385C6.43846 2.15385 4.96923 2.76154 3.86539 3.86539C2.76154 4.96923 2.15385 6.43846 2.15385 8C2.15385 9.56154 2.76154 11.0308 3.86539 12.1346C4.96923 13.2385 6.43846 13.8462 8 13.8462C9.56154 13.8462 11.0308 13.2385 12.1346 12.1346C13.2385 11.0308 13.8462 9.56154 13.8462 8C13.8462 6.43846 13.2385 4.96923 12.1346 3.86539Z",
    fill: "#FB6240"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1346 3.86535C11.0308 2.7615 9.56154 2.15381 8 2.15381C6.43846 2.15381 4.96923 2.7615 3.86539 3.86535C2.76154 4.96919 2.15385 6.43842 2.15385 7.99996C2.15385 9.5615 2.76154 11.0307 3.86539 12.1346C4.96923 13.2384 6.43846 13.8461 8 13.8461C9.56154 13.8461 11.0308 13.2384 12.1346 12.1346C13.2385 11.0307 13.8462 9.5615 13.8462 7.99996C13.8462 6.43842 13.2385 4.96919 12.1346 3.86535Z",
    fill: "#FB6240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosRadioButtonOn);
export default __webpack_public_path__ + "static/media/ios-radio-button-on.3afff7676633a62e583abef7b9b2778c.svg";
export { ForwardRef as ReactComponent };